import React, { useState } from "react";
import { Bar, Kpi, LineTable } from "./NpdShared";
import { ST, countByStatus, late, stg, topBy } from "./npdUtils";

// "Where we are lacking" insights, each with the view it links to
const insights = (lines, parts, today, go) => {
  const out = [];
  const D = parts.filter((p) => p.s === 3);
  const lr = lines
    .map((l) => {
      const lp = parts.filter((p) => p.L.id === l.id);
      return { l, r: lp.length ? lp.filter((p) => p.s === 3).length / lp.length : 0 };
    })
    .sort((a, b) => b.r - a.r)[0];
  if (lr && lr.r > 0) {
    out.push([`${lr.l.name} has the highest delay rate: ${Math.round(lr.r * 100)}% of its parts are delayed.`, () => go("tracker", { line: lr.l.id })]);
  }
  const b = topBy(D, (p) => p.buyerName || "Unassigned");
  const s = topBy(D, (p) => `${p.L.name} · ${stg(p)}`);
  const u = topBy(D, (p) => p.supplierName || "No supplier");
  if (b) out.push([`${b[0]} holds the most delayed parts (${b[1]}). Check workload and offer support.`, () => go("reports")]);
  if (s) out.push([`Most delays are stuck at ${s[0]} (${s[1]} parts). This is the biggest bottleneck.`, () => go("reports")]);
  if (u) out.push([`${u[0]} is linked to the most delayed parts (${u[1]}). Review this supplier.`, () => go("suppliers")]);
  const n = parts.filter((p) => p.s !== 3 && late(p, today) > 0).length;
  if (n) out.push([`${n} parts are past their target date but not marked delayed. Ask buyers to update them.`, () => go("parts")]);
  return out;
};

const MainDashboard = ({ app }) => {
  const { lines, parts, today, go } = app;
  const [q, setQ] = useState("");
  const [fl, setFl] = useState("");
  const tot = countByStatus(parts);
  const done = parts.length
    ? Math.round((parts.reduce((a, p) => a + p.cur / p.L.stages.length, 0) / parts.length) * 100)
    : 0;
  const lineCounts = (l) => countByStatus(parts.filter((p) => p.L.id === l.id));
  const ls = lines.filter(
    (l) => (l.name + l.product).toLowerCase().includes(q.toLowerCase()) && (!fl || lineCounts(l)[fl - 1] > 0)
  );
  const att = lines
    .map((l) => ({ l, n: parts.filter((p) => p.L.id === l.id).length, d: lineCounts(l)[3] }))
    .filter((x) => x.d > 0)
    .sort((a, b) => b.d / b.n - a.d / a.n);
  const gaps = insights(lines, parts, today, go);

  return (
    <>
      <h2>Main Dashboard</h2>
      <p className="sub">Overall status of the sourcing operation</p>
      <div className="kpis">
        <Kpi n={lines.length} label="Sourcing assignments" />
        <Kpi n={parts.length} label="Total parts" />
        <Kpi n={tot[0]} label="In progress" color="ip" />
        <Kpi n={tot[1]} label="Completed" color="ok" />
        <Kpi n={tot[2]} label="Under review" color="rv" />
        <Kpi n={tot[3]} label="Delayed" color="dl" />
        <Kpi n={parts.filter((p) => late(p, today) > 0).length} label="Past target date" color="dl" />
      </div>
      <div className="panel">
        <h3>Overall progress across all lines: {done}% of stages complete</h3>
        <Bar counts={tot} />
      </div>
      <div className="panel">
        <h3>Where we are lacking</h3>
        {gaps.length ? gaps.map(([text, onClick]) => (
          <div key={text} className="att" onClick={onClick}><span>{text}</span></div>
        )) : <div className="empty">No gaps found.</div>}
      </div>
      <div className="panel">
        <h3>Needs attention</h3>
        {att.length ? att.map((x) => (
          <div key={x.l.id} className="att" onClick={() => go("tracker", { line: x.l.id })}>
            <span>{x.l.name} · {x.l.product}</span>
            <span className="red">{x.d} delayed of {x.n}</span>
          </div>
        )) : <div className="empty">No delayed assignments.</div>}
      </div>
      <div className="panel">
        <h3>Assembly lines</h3>
        <div className="tools">
          <input placeholder="Search line or product" value={q} onChange={(e) => setQ(e.target.value)} />
          <select value={fl} onChange={(e) => setFl(e.target.value)}>
            <option value="">All statuses</option>
            {ST.map((s, i) => <option key={s} value={i + 1}>Has {s.toLowerCase()} parts</option>)}
          </select>
        </div>
        <div className="wrap">
          <LineTable lines={ls} parts={parts} onOpen={(l) => go("tracker", { line: l.id })} />
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
